export const RESET_ALL_DATA = "invite/RESET_ALL_DATA";
export const RESET_ALL_PROJECTS = "invite/RESET_ALL_PROJECTS";
export const SET_DATA = "invite/SET_DATA";
export const RESET = "invite/RESET";
